import {
  useEffect,
  useState,
} from 'react';
import {
  Edit3 as Edit3Icon,
  Lock,
  RefreshCcw,
  Trash2 as Trash2Icon,
  Unlock,
} from 'react-feather';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import { SimsoAction } from 'src/actions/simso.action';
import {
  CONFIRM_TYPES,
  DEFAULT_ROW_PER_PAGE,
  ROW_PER_PAGE_OPTIONS,
} from 'src/utils/constants';
import { getSimsoStatus } from 'src/utils/utils';
import ConfirmDialog from '../ConfirmDialog';
import {
  Box,
  Card,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  IconButton,
} from '@material-ui/core';
import CreateEditDialog from './CreateEditDialog';

import numeral from 'numeral';

import { isGrantPermission } from 'src/utils/utils';

const SimsoLookupDetail = ({ ...rest }) => {
  const dispatch = useDispatch()
  const [selectedSimsoIds, setSelectedSimsoIds] = useState([]);
  const [limit, setLimit] = useState(DEFAULT_ROW_PER_PAGE);
  const [page, setPage] = useState(0);
  const { items, total, filter } = useSelector(state => state.simso);
  const [confirm, setConfirm] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [selected, setSelected] = useState({});
  const [open, setOpen] = useState(false);
  const { info, permissions, role } = useSelector(state => state.profile)

  useEffect(() => {
    const payload = {
      ...filter,
      limit: limit,
      page: page,
    };
    dispatch(SimsoAction.updateFilter(payload));
    dispatch(SimsoAction.list())
  }, [page, limit])

  const handleSelectAll = (event) => {
    let newSelectedSimsoIds;

    if (event.target.checked) {
      newSelectedSimsoIds = items.map((simso) => simso.id);
    } else {
      newSelectedSimsoIds = [];
    }

    setSelectedSimsoIds(newSelectedSimsoIds);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedSimsoIds.indexOf(id);
    let newSelectedSimsoIds = [];

    if (selectedIndex === -1) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(selectedSimsoIds, id);
    } else if (selectedIndex === 0) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(selectedSimsoIds.slice(1));
    } else if (selectedIndex === selectedSimsoIds.length - 1) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(selectedSimsoIds.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSimsoIds = newSelectedSimsoIds.concat(
        selectedSimsoIds.slice(0, selectedIndex),
        selectedSimsoIds.slice(selectedIndex + 1)
      );
    }

    setSelectedSimsoIds(newSelectedSimsoIds);
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleConfirmOpen = (type, simso) => {
    setSelected(simso);
    setConfirmType(type);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      setTitle("Xoá bản ghi")
      setContent(`Xác nhận xoá bản ghi `)
    }
    setConfirm(true);
  };

  const onConfirm = () => {
    setConfirm(false);
    if (confirmType === CONFIRM_TYPES.DELETE) {
      dispatch(SimsoAction.del(selected.id))
      return;
    }
  }

  const handleConfirmClose = () => {
    setConfirm(false);
  };

  const onSelected = (id) => {
    dispatch(SimsoAction.findOne(id));
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const setColor = (value) => {
    if (value == 'MOBIFONE') return 'green';
    else if (value == 'VINAPHONE') return 'blue';
    else if (value == 'VIETTEL') return 'red';
    else return 'black';
  };

  return (
    <Card {...rest} style={{ width: "100%"}}>
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1500 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  #
                </TableCell>
                <TableCell>
                  Số điện thoại
                </TableCell>
                <TableCell>
                  Nhà mạng
                </TableCell>
                <TableCell>
                  Loại thuê bao
                </TableCell>
                {(role.priority < 3 || role.priority == 6) && <TableCell>
                  Nguồn nhập
                </TableCell>}
                {isGrantPermission(permissions, ["simso.giagoc"]) && <TableCell>
                  Giá gốc
                </TableCell>}
                {isGrantPermission(permissions, ["simso.giasi1"]) && <TableCell>
                  {(isGrantPermission(permissions, ["simso.giasi2"]) || isGrantPermission(permissions, ["simso.giasi3"])) ? 'Giá sỉ 1' : 'Giá'}
                </TableCell>}
                {isGrantPermission(permissions, ["simso.giasi2"]) && <TableCell>
                  {(isGrantPermission(permissions, ["simso.giasi1"]) || isGrantPermission(permissions, ["simso.giasi3"])) ? 'Giá sỉ 2' : 'Giá'}
                </TableCell>}
                {isGrantPermission(permissions, ["simso.giasi3"]) && <TableCell>
                  {(isGrantPermission(permissions, ["simso.giasi1"]) || isGrantPermission(permissions, ["simso.giasi2"])) ? 'Giá sỉ 3' : 'Giá'}
                </TableCell>}
                {isGrantPermission(permissions, ["simso.giakhachhang"]) && <TableCell>
                  Giá khách hàng
                </TableCell>}
                <TableCell>
                  Ghi chú
                </TableCell>
                <TableCell>
                  Trạng thái
                </TableCell>
                {(role.priority < 3 || role.priority == 6) && <TableCell>
                  Chức năng
                </TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {items && Object.values(items).length > 0 && items.slice(page * limit, page * limit + limit).map((simso, index) => (
                simso ? <TableRow
                  hover
                  key={simso.id}
                  selected={selectedSimsoIds.indexOf(simso.id) !== -1}
                >
                  <TableCell>
                    {page * limit + index + 1}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simso.so_dien_thoai_co_dau_cham}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color="textPrimary"
                      variant="body1"
                    >
                      {simso.nha_mang == "MOBIFONE" && <span style={{color: setColor('MOBIFONE'), fontWeight: "bold"}}>MOBIFONE</span>}
                      {simso.nha_mang == "VINAPHONE" && <span style={{color: setColor('VINAPHONE'), fontWeight: "bold"}}>VINAPHONE</span>}
                      {simso.nha_mang == "VIETTEL" && <span style={{color: setColor('VIETTEL'), fontWeight: "bold"}}>VIETTEL</span>}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={simso.number_type == 1 ? 'green' : (simso.number_type == 2 ? 'blue' : 'black')}
                      variant="body1"
                    >
                      {simso.number_type == 1 ? 'TRẢ TRƯỚC' : (simso.number_type == 2 ? 'TRẢ SAU' : '')}
                    </Typography>
                  </TableCell>
                  {(role.priority < 3 || role.priority == 6) && <TableCell>
                    {simso.nguon_nhap}
                  </TableCell>}
                  {isGrantPermission(permissions, ["simso.giagoc"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(simso.gia_goc).format('0,0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["simso.giasi1"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(simso.gia_si_1).format('0,0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["simso.giasi2"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(simso.gia_si_2).format('0,0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["simso.giasi3"]) && <TableCell>
                    <span style={{ fontWeight: 'bold' }}>
                      {numeral(simso.gia_si_3).format('0,0')}₫
                    </span>
                  </TableCell>}
                  {isGrantPermission(permissions, ["simso.giakhachhang"]) && <TableCell>
                    {(Number(simso.gia_khach_hang_khuyen_mai) > 0 && Number(simso.gia_khach_hang_khuyen_mai) < Number(simso.gia_khach_hang)) ? (
                      <div>
                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                          {numeral(simso.gia_khach_hang_khuyen_mai).format('0,0')}₫
                        </span>
                        &nbsp;
                        <span className='price-old' style={{ textDecoration: 'line-through', color: '#888' }}>
                          {numeral(simso.gia_khach_hang).format('0,0')}₫
                        </span>
                      </div>
                    ) : (
                      <div>
                        <span style={{ fontWeight: 'bold' }}>
                          {numeral(simso.gia_khach_hang).format('0,0')}₫
                        </span>
                      </div>
                    )}
                  </TableCell>}
                  <TableCell>
                    {simso.ghi_chu}
                  </TableCell>
                  <TableCell>
                    <Typography
                      color={simso.trang_thai == 'con_sim' ? 'green' : (simso.trang_thai == 'giu_so' ? 'orange' : 'red')}
                      variant="body1"
                    >
                      {simso.trang_thai == 'con_sim' ? 'Còn sim' : (simso.trang_thai == 'giu_so' ? 'Giữ số' : 'Đã bán')}
                    </Typography>
                  </TableCell>
                  {(role.priority < 3 || role.priority == 6) && <TableCell>
                    <IconButton aria-label="edit" onClick={() => onSelected(simso.id)}>
                      <Edit3Icon color='green' />
                    </IconButton>
                    <IconButton aria-label="delete" onClick={() => handleConfirmOpen(CONFIRM_TYPES.DELETE, simso)}>
                      <Trash2Icon color='red' />
                    </IconButton>
                  </TableCell>}
                </TableRow> : null
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={total}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
      />
      <CreateEditDialog open={open} handleClose={handleClose} type={"EDIT"} />
      <ConfirmDialog open={confirm} title={title} content={content || `Xác nhận xoá bản ghi `} highlight={selected.so_dien_thoai_co_dau_cham} handleClose={handleConfirmClose} handleConfirm={onConfirm} />
    </Card>
  );
};

export default SimsoLookupDetail;
